// @flow

import { type Country } from '@tectonics/prs/country';
import { type Decimal, type FormatDecimal, truncateDecimal } from '@tectonics/prs/money';

export function getMoneyFormat(country: Country): FormatDecimal {
  switch (country) {
    default:
      return (decimal: Decimal) => truncateDecimal(decimal).replace('.', ',');
  }
}
